import GraphConst from "../constants/graph";
import moment from "moment";
import { CallChannels, CallChannelKeys } from "./appointments";
import { ArrayUtil, isAlive } from ".";

const DATE = GraphConst.DATE;
const SESSIONS = GraphConst.SESSIONS;
const DATA_SET = {
	[DATE.YEAR]: { size: 12, pointer: "month", format: "MMM YY", titleFormat: "MMMM YYYY" },
	[DATE.MONTH]: { size: 31, pointer: "day", format: "D/MM", titleFormat: "D MMMM YYYY" },
	[DATE.WEEK]: { size: 7, pointer: "day", format: "DD MMM", titleFormat: "D MMMM YYYY" },
	[DATE.DAY]: { size: 24, pointer: "hour", format: "HH.00", titleFormat: "D MMMM YYYY" },
};
const makeDateSetValueGraph = ({source, viewBy, getDate = (d)=>d.date})=>{
	return source.map(target=>attachDateSetValue({target, viewBy, getDate}));
};
const attachDateSetValue = ({target, viewBy, getDate = (d)=>d.date})=>{
	const date = getDate(target);
	if(viewBy){
		return {
			...target,
			[viewBy]:mutateDateByViewBy({date, viewBy})
		};
	}else{
		return {
			...target,
			[DATE.YEAR]: moment(date).format(DATA_SET[DATE.YEAR].format),
			[DATE.MONTH]:moment(date).format(DATA_SET[DATE.MONTH].format),
			[DATE.WEEK]: moment(date).format(DATA_SET[DATE.WEEK].format),
			[DATE.DAY]:  moment(date).format(DATA_SET[DATE.DAY].format)
		};
	}
};
const mutateDateByViewBy = ({date, viewBy})=>{
	return moment(date,"X").format(DATA_SET[viewBy].format);
};
const createObjectTimeOf = ({selected, viewBy, move = 0, keyMod, defaultValue = 0})=>{
	const timeObject = {};
	const SET = DATA_SET[viewBy];
	const arrCount = new Array(SET.size).fill(undefined);
	arrCount.map((value, index) => {
		let count = 0;
		const date = selected ?
			moment(selected).add(index, SET.pointer) :
			moment(new Date()).subtract((SET.size - (1 + move)) - index, SET.pointer);
		timeObject[keyMod ? keyMod(date) : date] = {
			date,
			value: defaultValue
		};
	});
	return timeObject;
};
const calVisitGraph = ({ viewBy, appointments = [], selected = null, move = 0 }) => {

	if (selected) {
		switch (viewBy) {
		case DATE.MONTH: selected = moment(selected, "MMM YY"); break;
		case DATE.WEEK: selected = moment(selected, "D/MM"); break;
		case DATE.DAY: selected = moment(selected, "DD MMM"); break;
		default:
			break;
		}
	}
	const SET = DATA_SET[viewBy];
	const arrCount = new Array(SET.size).fill(undefined);
	const arrData = Object.keys(SESSIONS).map(sec => arrCount.map((value, index) => {
		let count = 0;
		const date = selected ?
			moment(selected).add(index, SET.pointer) :
			moment(new Date()).subtract((SET.size - (1 + move)) - index, SET.pointer);
		appointments.map(appointment => {
			if (date.isSame(moment.unix(appointment.created), SET.pointer)) {
				if (SESSIONS[sec] === SESSIONS.ALL) count += 1;
				else if (SESSIONS[sec] === SESSIONS.APP && appointment.call_channel === CallChannelKeys.WEB) count += 1;
				else if (SESSIONS[sec] === SESSIONS.HOTLINE && appointment.call_channel === CallChannelKeys.PHONE) count += 1;
			}
		});
		return {
			section: SESSIONS[sec],
			title: date.format(SET.format),
			date: date,
			value: count,
		};
	}));

	const data = [].concat.apply([], arrData);
	return data;
};

const calVisitTitle = (data) => {
	const first = data[0].date.format("D MMMM YYYY");
	const last = data[data.length - 1].date.format("D MMMM YYYY");
	if (first === last) return `${first}`;
	else return `${first} - ${last}`;
};

const calVisitLength = (appointments) => {
	const all = appointments.length;
	const app = appointments.filter(value => value.call_channel === CallChannelKeys.WEB).length;
	const hotline = appointments.filter(value => value.call_channel === CallChannelKeys.PHONE).length;
	return { all, app, hotline };
};

const calFrequencyTitle = (date_range) => {
	if (ArrayUtil.isAliveArray(date_range) && isAlive(date_range[0]) && isAlive(date_range[1])) {
		const first = moment.unix(date_range[0]).format("D MMMM YYYY");
		const last = moment.unix(date_range[1]).format("D MMMM YYYY");
		return `${first} - ${last}`;
	} else {
		return "All Time";
	}
};

const calFrequencyGraph = (data, date_range) => {
	if (data.length == 0) return;
	const dateFormat = "D/MM/YYYY";
	const firstDate = date_range && date_range[0] ?
		moment.unix(date_range[0]) :
		moment(data[0].date, dateFormat);
	const lasteDate = date_range && date_range[1] ?
		moment.unix(date_range[1]) :
		moment(data[data.length - 1].date, dateFormat);
	let configGraph = { type: "year", format: "YYYY" };
	let newData = [];
	if (!firstDate.isSame(lasteDate, "year")) configGraph = { type: "year", format: "YYYY" };
	else if (!firstDate.isSame(lasteDate, "month")) configGraph = { type: "month", format: "MMM YY" };
	else if (!firstDate.isSame(lasteDate, "day")) configGraph = { type: "day", format: "D" };
	else return newData;
	const valueDiff = Math.abs(lasteDate.diff(firstDate, configGraph.type));
	const diff = valueDiff == 0 ? 1 : valueDiff;
	const tempData = {};
	for (let i = 0; i <= diff; i++) {
		const increaseDate = firstDate.add(i === 0 ? 0 : 1, configGraph.type).format(configGraph.format);
		data.map(value => {
			const dateValue = moment(value.date, dateFormat).format(configGraph.format);
			if (dateValue === increaseDate) {
				if (tempData[increaseDate]) tempData[increaseDate] += value.value;
				else tempData[increaseDate] = value.value;
			} else {
				if (!tempData[increaseDate]) tempData[increaseDate] = 0;
			}
		});
	}
	newData = Object.keys(tempData).map(key => { return { date: key, value: tempData[key] }; });
	return newData;
};

export { calVisitGraph, calVisitTitle, calVisitLength, calFrequencyGraph, calFrequencyTitle, 
	makeDateSetValueGraph, attachDateSetValue, mutateDateByViewBy, createObjectTimeOf };


// WEBPACK FOOTER //
// ./src/util/graph.js